module.exports = __webpack_public_path__ + "img/stylus-trans-cc.8a6f1c55.png";